import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { BusinessThemeService } from './models';
import { CSSThemeService, DefaultBusinessThemeService, DummyThemeService, ThemeManagerService, USE_THEMES } from './services';
import { DebtorKpiColorPipe } from './pipes';
import { KpiColorDirective } from './directives';
import { ThemeSwitcherComponent } from './components/theme-switcher/theme-switcher.component';


const declarations = [
    ThemeSwitcherComponent,
    DebtorKpiColorPipe,
]

@NgModule({
	declarations,
	exports: declarations,
	imports: [
		CommonModule,
        KpiColorDirective,
        TranslateModule,
	],
	providers: [
        CSSThemeService,
        DefaultBusinessThemeService
    ],
})
export class ThemesModule {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static forRoot(config: any): ModuleWithProviders<ThemesModule> {
        return {
            ngModule: ThemesModule,
            providers: [
                {provide: USE_THEMES, useValue: config.themes || []},
                config.cssThemeService || {provide: CSSThemeService, useClass: DummyThemeService},
                config.businessThemeService || {provide: BusinessThemeService, useClass: DummyThemeService},
                ThemeManagerService,
            ],
        };
    }
}
